import { useContext } from 'react';
import { TokenMapContext } from '../contexts/TokenMapContext';

const useTokenMap = () => {
  const context = useContext(TokenMapContext);
  if (!context) {
    throw new Error('useTokenMap must be used within a TokenMapProvider');
  }
  return context;
};

export default useTokenMap;
